/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResendOrganisationMembershipInvitationEmailMutationVariables = Types.Exact<{
  input: Types.ResendOrganisationMembershipInvitationEmailInput;
}>;


export type ResendOrganisationMembershipInvitationEmailMutation = { resendOrganisationMembershipInvitationEmail: { __typename: 'ResendOrganisationMembershipInvitationEmailResult', invitation: { __typename: 'OrganisationMembershipInvitation', id: string, status: Types.OrganisationMembershipInvitationStatus } } };


export const ResendOrganisationMembershipInvitationEmailDocument = gql`
    mutation ResendOrganisationMembershipInvitationEmail($input: ResendOrganisationMembershipInvitationEmailInput!) {
  resendOrganisationMembershipInvitationEmail(input: $input) {
    invitation {
      id
      status
    }
  }
}
    `;
export type ResendOrganisationMembershipInvitationEmailMutationFn = Apollo.MutationFunction<ResendOrganisationMembershipInvitationEmailMutation, ResendOrganisationMembershipInvitationEmailMutationVariables>;

/**
 * __useResendOrganisationMembershipInvitationEmailMutation__
 *
 * To run a mutation, you first call `useResendOrganisationMembershipInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOrganisationMembershipInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOrganisationMembershipInvitationEmailMutation, { data, loading, error }] = useResendOrganisationMembershipInvitationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendOrganisationMembershipInvitationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendOrganisationMembershipInvitationEmailMutation, ResendOrganisationMembershipInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOrganisationMembershipInvitationEmailMutation, ResendOrganisationMembershipInvitationEmailMutationVariables>(ResendOrganisationMembershipInvitationEmailDocument, options);
      }
export type ResendOrganisationMembershipInvitationEmailMutationHookResult = ReturnType<typeof useResendOrganisationMembershipInvitationEmailMutation>;
export type ResendOrganisationMembershipInvitationEmailMutationResult = Apollo.MutationResult<ResendOrganisationMembershipInvitationEmailMutation>;
export type ResendOrganisationMembershipInvitationEmailMutationOptions = Apollo.BaseMutationOptions<ResendOrganisationMembershipInvitationEmailMutation, ResendOrganisationMembershipInvitationEmailMutationVariables>;